const TEMPLATE_TYPE_CUSTOMERS = {
  id: "18da1bba-b16e-4e4f-b243-6d50c94480b6",
  temperature: "customers",
  name: "Zákazníci",
  color: "green",
}

const TEMPLATE_TYPE_HOT = {
  id: "275c1e1f-5409-44f5-98dd-34191da3906c",
  temperature: "hot",
  name: "Horká návštěvnost",
  color: "red",
}

const TEMPLATE_TYPE_WARM = {
  id: "ceb785e0-4e6d-4623-b497-4855b3a981a2",
  temperature: "warm",
  name: "Ohřátá návštěvnost",
  color: "amber",
}

const TEMPLATE_TYPE_LUKEWARM = {
  id: "4f56af0b-f81a-4f16-a2dc-3bd42b9b7081",
  temperature: "lukewarm",
  name: "Vlažná návštěvnost",
  color: "indigo",
}

const TEMPLATES_TYPES = [
  { ...TEMPLATE_TYPE_CUSTOMERS },
  { ...TEMPLATE_TYPE_HOT },
  { ...TEMPLATE_TYPE_WARM },
  { ...TEMPLATE_TYPE_LUKEWARM },
]

const TEMPLATES = [
  /* {
    id: "86db4933-4221-434f-abc7-bbf545e4b624",
    name: "Všichni zákazníci konkrétního produktu",
    description:
      "Toto publikum chcete vždy vyloučit, pokud nabízíte daný produkt za výhodnějších podmínek (např Black friday sleva atp.)",
    type: { ...TEMPLATE_TYPE_CUSTOMERS },
    rule: {
      inclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 15552000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },*/
  {
    id: "b72c7564-e049-49b0-a158-194e9c5bf93a",
    name: "Návštěvníci konkrétní stránky webu",
    description:
      "Publikum složené výhradně z návštěvníků konkrétní stránky na vašem webu v uplynulých X dnech, které můžete dále upřesnit (např. jen ženy ve věku 20 - 40 let, které mají rády psy a byly na konkrétní stránce u vás).\n",
    // type: { ...TEMPLATE_TYPE_CUSTOMERS },
    rule: {
      inclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 15552000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  } /*
  {
    id: "3e4a3e81-d690-4e46-9c1b-9db79ee0d5f0",
    name: "Noví zákazníci konkrétního produktu",
    description:
      "Vaši nejnovější zákazníci (>10 dnů). Těmto lidem chcete ukazovat nabídky s tzv. upsellem, tedy produktem, který se váže k produktu, co si od vás koupili.",
    type: { ...TEMPLATE_TYPE_CUSTOMERS },
    rule: {
      inclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 864000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },
  {
    id: "2515a843-b463-42e0-9a8a-ddfd53d61d99",
    name: "Všichni zákazníci všech produktů",
    description:
      "Creme de la creme. Všichni lidé, kteří od vás v uplynulých 6 měsících nakoupili. Těmto lidem chceme přednostně nabízet nové produkty za zvýhodněných podmínek, slevy za loajálnost, předprodejní kampaně atp.",
    type: { ...TEMPLATE_TYPE_CUSTOMERS },
    rule: {
      inclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 15552000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },
  {
    id: "ee30ce12-0d39-4696-86ca-8f760166eae0",
    name: "Potenciální zákazníci",
    description:
      "Toto publikum tvoří lidé, kteří v uplynulých 10 dnech navštívili prodejní stránku vašeho produktu, strávili na ní hodně času, ale nekoupili si váš produkt. Zobrazujete jim reklamu, která podtrhuje přednosti a výhody vašeho produktu, nabízí nové bonusy či jiná zvýhodnění - pobídka k akci, aby se člověk vrátil na vaši prodejní stránku a dokončil objednávku.",
    type: { ...TEMPLATE_TYPE_HOT },
    rule: {
      inclusions: {
        operator: "and",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 864000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            aggregation: {
              type: "time_spent",
              method: "percentile",
              operator: "in_range",
              value: {
                from: 90,
                to: 100,
              },
            },
            template: "TOP_TIME_SPENDERS",
          },
        ],
      },
      exclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 15552000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },
  {
    id: "e9f6e0f4-345b-4995-9f0d-7641cb38320d",
    name: "Vracející se potenciální zákaznici",
    description:
      "Toto publikum tvoří lidé, kteří v uplynulých 10 dnech navštívili nejméně 2x prodejní stránku vašeho produktu, ale nekoupili si váš produkt. Zobrazujete jim reklamu, která podtrhuje přednosti a výhody vašeho produktu, nabízí nové bonusy či jiná zvýhodnění - pobídka k akci, aby se člověk vrátil na vaši prodejní stránku a dokončil objednávku.",
    type: { ...TEMPLATE_TYPE_HOT },
    rule: {
      inclusions: {
        operator: "and",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 864000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            aggregation: {
              type: "count",
              method: "absolute",
              operator: ">=",
              value: 2,
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
      exclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 15552000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_not_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },*/,
  {
    id: "612c903f-a4ea-4aa5-9da1-1f385a4c228b",
    name: "Návštěvníci stránky 1, kteří nebyli na stránce 2",
    description:
      "Tuto šablonu použijte v případě, že chcete určit 2 podmínky, například lidé, kteří byli na objednávkové stránce, ale nebyli na děkovací, nebo byli na registrační stránce, ale nebyli na děkovací za registraci. Publikum můžete zase zpřesňovat a zužovat (např. muži 24 - 32 z okolí Liberce, kteří byli na stránce 1, ale nebyli na stránce 2).",
    // type: { ...TEMPLATE_TYPE_WARM },
    rule: {
      inclusions: {
        operator: "and",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 864000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
      exclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 864000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_not_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },
  /*
  {
    id: "924ca6f5-ab61-43fe-b9cb-987dd4d6a639",
    name: "Čtenáři blogu",
    description:
      "Lidé, kteří v uplynulých 30 dnech minimálně 2x navštívili váš blog, ale nekoupili si váš produkt. Tyto lidi se snažíte povzbudit, inspirovat, připomenout jim, jak jim může váš produkt pomoci zlepšit jejich situaci. Můžete je buď posílat na stránku s magnetem nebo na prodejní stránku.",
    type: { ...TEMPLATE_TYPE_LUKEWARM },
    rule: {
      inclusions: {
        operator: "and",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 2592000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            aggregation: {
              type: "count",
              method: "absolute",
              operator: ">=",
              value: 2,
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
      exclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 15552000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_not_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },
  {
    id: "26c5a388-0780-45c1-ba00-78298f4d1e05",
    name: "Sympatizanti",
    description:
      "Lidé, kteří v uplynulých 30 dnech vícekrát (3x a více) navštívili váš web, ale nic si od vás nekoupili. Tito lidé vás / vaši značku znají, vrací se k vám, ale nekupují. Testujte strategie, jak je přeměnit na zákazníky. Např: doručujte jim více obsahu zdarma, ukazujte jim, jak jiným lidem pomáhá vaše řešení.",
    type: { ...TEMPLATE_TYPE_LUKEWARM },
    rule: {
      inclusions: {
        operator: "and",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 2592000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_contains",
                  value: "",
                },
              ],
            },
            aggregation: {
              type: "count",
              method: "absolute",
              operator: ">=",
              value: 3,
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
      exclusions: {
        operator: "or",
        rules: [
          {
            eventSources: [{}],
            retentionSeconds: 15552000,
            filter: {
              operator: "and",
              filters: [
                {
                  field: "url",
                  operator: "i_not_contains",
                  value: "",
                },
              ],
            },
            template: "VISITORS_BY_URL",
          },
        ],
      },
    },
  },*/
]

export { TEMPLATES, TEMPLATES_TYPES }
